import axios from 'axios';
import { Modal } from 'antd-mobile';
import { stringify } from 'qs';
import { queryParse } from './query';

const { token = '', userId = 0 } = queryParse(window.location.search);

const { alert } = Modal;

const showAlert = (msg = '系统错误，请稍后再试') => {
  alert('提示', msg, [
    { text: '知道了' },
  ]);
};

axios.defaults.baseURL = '';
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';
axios.defaults.headers.common.token = token;
const fetch = (url, options) => {
  let { method = 'get', data } = options;
  data = Object.assign({}, data, { token, userId });
  switch (method.toLowerCase()) {
    case 'get':
      return axios.get(url, { params: data });
    case 'delete':
      return axios.delete(url, { data });
    case 'head':
      return axios.head(url, data);
    case 'post':
      return axios.post(url, data);
    case 'put':
      return axios.put(url, stringify(data));
    case 'patch':
      return axios.patch(url, data);
    default:
      return axios(options);
  }
};

function checkStatus(res) {
  if (res.status >= 200 && res.status < 300) {
    return res;
  }
  const error = new Error(res.statusText);
  error.response = res;
  throw error;
}

function handelData(res) {
  const data = res.data || {};
  if (data && (Number(data.code) !== 200)) {
    // showAlert(data.msg || '系统错误，请稍后再试');
    const error = new Error(res.statusText);
    error.response = res;
    throw error;
  } else {
    return data;
  }
}

function handleError(error) {
  const data = error.response.data || {};
  if (data.errors) {
    showAlert(`${data.msg}：${data.errors}`);
  } else if (data.error) {
    showAlert(`${data.error}：${data.error_description}`);
  } else {
    showAlert(data.msg || data.detail || '未知错误！');
  }
  throw error;
  // return { success: false };
}

export default function request(url, options) {
  /* if (url !== '/oauth/token' && url !== '/admin/check') {
    url = `${url}?access_token=${Cookie.get('access_token')}`
  } */

  return fetch(url, options)
    .then(checkStatus)
    .then(handelData)
    .catch(handleError);
}

export function get(url, options) {
  return request(url, { ...options, method: 'get' });
}

export function post(url, options) {
  return request(url, { ...options, method: 'post' });
}

export function put(url, options) {
  return request(url, { ...options, method: 'put' });
}

export function deleted(url, options) {
  return request(url, { ...options, method: 'deleted' });
}



// WEBPACK FOOTER //
// ./src/utils/request.js